import { mapKeysToSnakeCase } from '@skytech/utils'

import { API_ROUTE_ADMIN_ASSET } from '@/resources/api-routes'
import { post } from '@/util/auth'

import type { ResultStatusOriginal } from './types'

export const updateAsset = async ({
  id,
  payload,
}: {
  id: number
  payload: {
    typeId: number | string
    statusId: number | string
    userTypeId: number | string
    ownershipTypeId: number | string
    returnStatusId: number | null
    costObjectId: number | string
    customerId: number
    assetDescription: string
    imei: string
    snr: string
    cost: number
    received: string
    leaseStart: string
    leaseEnd: string
    deleteCertificate: boolean
    deleteCertificateDate: string
    result: ResultStatusOriginal | null
    resultCost: number
    comment: string
    userName?: string
    ecomPolicyId?: number
  }
}) => {
  const snakeCasePayload = mapKeysToSnakeCase(payload)
  return post<null>(API_ROUTE_ADMIN_ASSET.replace(':assetId', String(id)), snakeCasePayload)
}
